import { EssentialTypesMapping } from 'api/client/mapping/essential-types-mapping';
import { GeneralIdentityApi, SessionIdentity } from 'api/general-identity';
import { SystemUsersClient } from 'api/swagger/ApiClient';
import { autoinject } from "aurelia-framework";
import { DeviationTeamType } from "model/business-enums";
import { GeneralKeywordsApi } from '../general-keywords';

@autoinject
export class GeneralIdentityClientApi implements GeneralIdentityApi {
  constructor(private systemUsersClient: SystemUsersClient, private essentialTypesMapping: EssentialTypesMapping, private api: GeneralKeywordsApi) {
  }

  async getSessionIdentity(): Promise<SessionIdentity> {
    const dto = await this.systemUsersClient.getCurrentUser();
    const deviationTeams = await this.api.getDeviationTeams();
    const ricDeviationTeam = deviationTeams.filter(x => x.teamType.value === DeviationTeamType.RIC)[0];
    const aviationTeam = deviationTeams.filter(x => x.teamType.value === DeviationTeamType.Aviation)[0];
    return {
      user: this.essentialTypesMapping.mapSystemUserDetailToUserDetail(dto),
      roles: {
        isAdmin: dto.systemRoles.flags.some(x => x.value === 1),
        isApprover: dto.systemRoles.flags.some(x => x.value === 2),
        isDelegate: dto.systemRoles.flags.some(x => x.value === 4),
        isDeviationsTeamMember: dto.systemRoles.flags.some(x => x.value === 8),
        isDeviationsAviationTeamMember: dto.systemRoles.flags.some(x => x.value === 8) && ((aviationTeam.teamLeader !== null && aviationTeam.teamLeader.id === dto.id) || aviationTeam.members.some(x => x.id === dto.id)),
        isDeviationsRICTeamMember: dto.systemRoles.flags.some(x => x.value === 8) && ((ricDeviationTeam.teamLeader !== null && ricDeviationTeam.teamLeader.id === dto.id) || ricDeviationTeam.members.some(x => x.id === dto.id))
      }
    }
  }
}
